import { axios } from '@/plugins/http-axios';
import { Module } from 'vuex';


// Интерфейс состояния модуля documents
 export interface IDocumentsState {
  signedDocTypes: any[];        // Список типов подписанных документов
  bankSignatories: any[];         // Список подписантов от Банка
  participantSignatories: any[];  // Список подписантов от Контрагента

}

const state: IDocumentsState = {
  signedDocTypes: [],
  bankSignatories: [],
  participantSignatories: [],
};

const getters = {
  // Геттер возвращает список типов подписанных документов
  listSignedDocTypes: (state: IDocumentsState): any[] => state.signedDocTypes,
  // Геттер возвращает список подписантов от Банка
  listBankSignatory: (state: IDocumentsState): any[] => state.bankSignatories,
  // Геттер возвращает список подписантов от Контрагента
  listParticipantSignatory: (state: IDocumentsState): any[] => state.participantSignatories,
};

const mutations = {
  // Мутация для установки типов подписанных документов
  setSignedDocTypes(state: IDocumentsState, data: any[] = []) {
    state.signedDocTypes = data;
  },
  // Мутация для установки подписантов от Банка
  setBankSignatories(state: IDocumentsState, data: any[] = []) {
    state.bankSignatories = data;
  },
  // Мутация для установки подписантов от Контрагента
  setParticipantSignatories(state: IDocumentsState, data: any[] = []) {
    state.participantSignatories = data;
  },
};

const actions = {
  // Экшен для получения типов подписанных документов
  getSignedDocTypes({ getters, commit, rootGetters }: any, appId: string): Promise<any[]> {
    if (getters.listSignedDocTypes && getters.listSignedDocTypes.length > 0) {
      return Promise.resolve(getters.listSignedDocTypes);
    }
    const url = rootGetters.uri.signedDocTypes(appId);
    return axios.get(url)
      .then((resp) => {
        commit('setSignedDocTypes', resp.data);
        return getters.listSignedDocTypes;
      })
      .catch((e) => {
        e.uri = url;
        return Promise.reject(e);
      });
  },
  // Экшен для получения подписантов от Банка
  getBankSignatories({ getters, commit, rootGetters }: any, appId: string): Promise<any[]> {
    if (getters.listBankSignatory && getters.listBankSignatory.length > 0) {
      return Promise.resolve(getters.listBankSignatory);
    }
    // Проверка наличия bankoffice в заявке
    if (!rootGetters.app || !rootGetters.app.application || !rootGetters.app.application.bankoffice?.id) {
      return Promise.resolve([]);
    }
    const url = rootGetters.uri.bankSignatoriesByOfficeId(rootGetters.app.application.bankoffice.id);
    return axios.get(url)
      .then((resp) => {
        commit('setBankSignatories', resp.data);
        return getters.listBankSignatory;
      })
      .catch((e) => {
        e.uri = url;
        return Promise.reject(e);
      });
  },
  // Экшен для получения подписантов от Контрагента
  getParticipantSignatories({ getters, commit, rootGetters }: any, appId: string): Promise<any[]> {
    if (getters.listParticipantSignatory && getters.listParticipantSignatory.length > 0) {
      return Promise.resolve(getters.listParticipantSignatory);
    }
    const url = rootGetters.uri.participantSignatories(appId);
    return axios.get(url)
      .then((resp) => {
        commit('setParticipantSignatories', resp.data);
        return getters.listParticipantSignatory;
      })
      .catch((e) => {
        e.uri = url;
        return Promise.reject(e);
      });
  },
};

const documents: Module<IDocumentsState, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default documents;
